import { Component, OnInit, ViewChild } from '@angular/core';
import { ThesisOrderStatusesEnum } from '../../../../../core-frontend-common/constants/thesis-order';
import { OriginalityService } from '../../../../services/originality.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { createSubQuery } from '../../../../../core-frontend-common/misc/query-designer/query-designer-functions';
import { queryFilterTypes, queryOperators } from '../../../../../core-frontend-common/misc/query-designer/query-designer';
import { ThesisOrderMail } from '../../components/thesis-order-mail/thesis-order-mail';
import { EpcProjectModel } from '../../../../models/epc-project.model';

@Component({
  selector: 'smart-originality-orders-list',
  templateUrl: './originality-orders-list.component.html',
  styleUrls: ['./originality-orders-list.component.scss']
})
export class OriginalityOrdersListComponent implements OnInit {

  originalityData = [];

  thesisOrderId: number;

  thesisOrderStatusResponse: any = {};

  @ViewChild(ThesisOrderMail, {static: false}) thesisOrderMail: ThesisOrderMail;

  constructor(
    private _originalityService: OriginalityService,
    protected notification: ToastrService
  ) { }

  ngOnInit() {

    this.loadOriginalityData();

  }

  loadOriginalityData() {
    const query = {
      status: {},
    };

    query.status = createSubQuery(queryOperators.OR, [
      ThesisOrderStatusesEnum.pko_evaluation_failure,
      ThesisOrderStatusesEnum.created
    ], 'status', queryFilterTypes.EQUAL);

    const queryDesigner = {
      'search': [],
      'where': {
        'operatorType': 'AND',
        'operands': []
      },
      'orderBy': [
        {
          'field': 'CreatedDatetime',
          'order': 'DESC'
        },
        {
          'field': 'Id',
          'order': 'DESC'
        }
      ]
    };

    Object.keys(query)
      .forEach(queryItem => {
        if (Object.keys(query[queryItem]).length > 0 && queryItem !== 'search') {
          queryDesigner['where']['operands'].push(query[queryItem]);
        }
      });

    this._originalityService
      .getOriginalityDataByFilter(queryDesigner)
      .subscribe(v => this.originalityData = v.items);
  }

  fulfillOrderData(order) {
    this.thesisOrderId = order.id;
  }

  getThesisOrderStatus() {
    if (!this.thesisOrderId || this.thesisOrderId === 0) {
      return;
    }

    const errors = {};

    this._originalityService
      .getStatusByOrderId(this.thesisOrderId)
      .subscribe(v => {
        this.thesisOrderStatusResponse = v;
        this.notification.success('Úspech.');
      }, (e: HttpErrorResponse) => {
        errors['status'] = {
          'status': e.status,
          'statusText': e.statusText
        };
        if (e && e.error && e.error.errors) {
          e.error.errors.forEach(error => errors[error.code] = error);
          this.thesisOrderStatusResponse = errors
        }
        this.notification.error(e.statusText);
      });
  }

  resetThesisOrderStatus() {
    this.thesisOrderId = null;
    this.thesisOrderStatusResponse = {};
  }

  sendThesisOrderEmail(order) {
    this.thesisOrderMail.openModal(order, () => {
      this.loadOriginalityData();
    });
  }

}
